import script from "./Profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./Profile.vue?vue&type=script&setup=true&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=451e489a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451e489a"]])

export default __exports__